import type { FC } from 'react';
import {
    Box,
    Container,
    Typography,
    Card,
    Stack,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import BoltIcon from '@mui/icons-material/Bolt';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';

export const PlatformWeBuilt: FC = () => {
    return (
        <Box
            sx={{
                py: 15,
                backgroundColor: '#0B0F18',
                width: '100vw',
                position: 'relative',
                marginLeft: 'calc(-50vw + 50%)',
                marginRight: 'calc(-50vw + 50%)',
                overflow: 'hidden'
            }}
        >
            <Container maxWidth="lg">
                <Stack
                    spacing={3}
                    alignItems="center"
                    textAlign="center"
                    mb={8}
                >
                    <Typography variant="h3"
sx={{
                        fontWeight: 600,
                        color: 'common.white'
                    }}>
                        The platform we've built
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: '1.125rem',
                            maxWidth: '800px',
                            color: alpha('#fff', 0.7)
                        }}
                    >
                        Bringing crypto to your business - Empower your users with the most competitive buy/sell rates
                    </Typography>
                </Stack>

                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    spacing={4}
                    justifyContent="center"
                    alignItems="stretch"
                >
                    {/* Onramp Card */}
                    <Card
                        sx={{
                            p: 4,
                            flex: 1,
                            backgroundColor: 'transparent',
                            border: '1px solid',
                            borderColor: alpha('#fff', 0.1),
                            background: alpha('#1E2837', 0.6),
                            backdropFilter: 'blur(6px)',
                            borderRadius: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            minWidth: { xs: '100%', md: '400px' },
                        }}
                    >
                        <Box
                            sx={{
                                mb: 3,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '80px',
                                height: '80px',
                            }}
                        >
                            <BoltIcon
                                sx={{
                                    fontSize: '64px',
                                    color: 'primary.main'
                                }}
                            />
                        </Box>
                        <Typography variant="h4"
sx={{
                            mb: 2,
                            fontWeight: 600,
                            color: 'common.white'
                        }}>
                            Lightning fast Onramp
                        </Typography>
                        <Typography variant="body1"
sx={{
                            mb: 3,
                            color: alpha('#fff', 0.7)
                        }}>
                            30+ Currencies | 400+ tokens
                        </Typography>
                    </Card>

                    {/* Offramp Card */}
                    <Card
                        sx={{
                            p: 4,
                            flex: 1,
                            backgroundColor: 'transparent',
                            border: '1px solid',
                            borderColor: alpha('#fff', 0.1),
                            background: alpha('#1E2837', 0.6),
                            backdropFilter: 'blur(6px)',
                            borderRadius: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            minWidth: { xs: '100%', md: '400px' },
                        }}
                    >
                        <Box
                            sx={{
                                mb: 3,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '80px',
                                height: '80px',
                            }}
                        >
                            <CurrencyExchangeIcon
                                sx={{
                                    fontSize: '64px',
                                    color: 'primary.main'
                                }}
                            />
                        </Box>
                        <Typography variant="h4"
sx={{
                            mb: 2,
                            fontWeight: 600,
                            color: 'common.white'
                        }}>
                            Lightning fast Offramp
                        </Typography>
                        <Typography variant="body1"
sx={{
                            mb: 3,
                            color: alpha('#fff', 0.7)
                        }}>
                            30+ Currencies | 400+ tokens
                        </Typography>
                    </Card>
                </Stack>
            </Container>
        </Box>
    );
}; 